import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  style: {"margin-bottom":"0"},
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AFE614",
      "fill-rule": "evenodd",
      d: "M1.479 8a6.67 6.67 0 0 1 6.667-6.667A6.67 6.67 0 0 1 14.812 8a6.669 6.669 0 0 1-6.666 6.667A6.669 6.669 0 0 1 1.479 8Zm7.5-2.5H7.311V3.833h1.666V5.5Zm-1.667 6.667v-5h1.666v5H7.312Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "info"}) } }